export { default as PagedPdfViewer } from './PDFViewer'
